import { Button } from "@mui/material";
import { closeSnackbar, SnackbarKey } from "notistack";
import { Link as RouterLink } from "react-router-dom";

/**
 * Reusable snackbar action that shows an "Upgrade" button linking to billing.
 * Usage: enqueueSnackbar("msg", { action: (key) => SnackbarUpgradeAction(key) })
 *
 * Uses RouterLink for SPA navigation. Requires SnackbarProvider to be mounted
 * inside the RouterProvider tree — see App.tsx RouterShell.
 */
export const SnackbarUpgradeAction = (key: SnackbarKey) => (
  <Button
    variant="text"
    size="small"
    component={RouterLink}
    to="/account/billing/plan"
    onClick={() => closeSnackbar(key)}
    sx={{ color: "inherit", fontWeight: 600, textDecoration: "underline" }}
  >
    Upgrade
  </Button>
);
